// extracted by mini-css-extract-plugin
module.exports = {"container":"Income_container__2SXai","center":"Income_center__34IV7"};